import { environment } from "@env/environment";
import { StorageContainersEnum } from "app/shared/enums/blob-storage.enum";
import { BlobStorageService } from "app/shared/services/blob-storage.service";

export class ImageUploadAdapter {
  private loader: any;

  constructor(loader: any, private blobStorageService: BlobStorageService) {
    this.loader = loader;
  }

  upload(): Promise<{ default: string }> {
    return this.loader.file.then((file: File) => {
      return this.blobStorageService.uploadFile(file, StorageContainersEnum.IMAGE).toPromise().then((res: any) => {

        return { default: `https://${environment.appConfig.blobStorageResourceName}.blob.core.windows.net/${environment.appConfig.blobStorageImagesContainerName}/${res.blobStorageId}` }; // CKEditor expects an object with `default` key
      });
    });
  }

  abort() {
    // Implement abort logic if needed
  }
}
